<template>
	<div class="winners-scroll" @click="$emit('click')">
		<div class="winners-scroll__mouse"><span /></div>
		<span
			class="winners-scroll__text"
			v-html="$translations.general.misc.winners_scroll"
		/>
	</div>
</template>

<script>
export default {
	selector: "[data-vue-winners-scroll]"
};
</script>

<style lang="scss" scoped>
.winners-scroll {
	display: flex;
	color: $white;
	align-items: center;
	transition: opacity 0.2s ease-out;
	cursor: pointer;

	@include media("<=phone") {
		display: none;
	}

	&:hover {
		opacity: 0.8;
	}

	&__mouse {
		font-size: 9px; /* CONTROL MOUSE SIZE */
		border: 2px solid rgba(255, 255, 255, 1);
		display: block;
		width: 1.7em;
		height: 2.8em;
		border-radius: 0.9em;
		margin: 0 auto;
		text-decoration: none;
		transition: all 0.2s ease-out;

		span {
			display: block;
			background: #fff;
			width: 0.2em;
			height: 0.3em;
			margin: 0.7em auto 0;
			border-radius: 0.4em;
			animation-name: hero-mouse-scroll;
			animation-duration: 1.5s;
			animation-timing-function: cubic-bezier(0.65, -0.55, 0.25, 1.5);
			animation-iteration-count: infinite;
			will-change: transform;
		}
	}

	&__text {
		display: inline-block;
		margin-left: 16px;
		text-transform: uppercase;
		font-size: 10px;
		letter-spacing: 2px;
		font-weight: 700;
	}
}

@keyframes hero-mouse-scroll {
	0%,
	20% {
		transform: translateY(0) scaleY(1);
	}
	10% {
		opacity: 1;
	}
	100% {
		transform: translateY(1.2em) scaleY(1.5);
		opacity: 0.01;
	}
}
</style>